import React, {Component} from "react";
import {BACKEND_API_HOST} from "../../../../helper/host";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Swal from "sweetalert2";

class ImportFinance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    }
  }

  exportTemplate = () => {
    var AuthKey = localStorage.getItem('Presensi-Auth-Key')
    window.open(BACKEND_API_HOST + 'finance/export?token=' + AuthKey + '&template=true', "_blank")
  }

  importExcel = () => {
    this.setState({
      loading: true
    })

    var AuthKey = localStorage.getItem('Presensi-Auth-Key')

    let formData = new FormData()
    formData.append('file', this.state.importFile)
    formData.append('token', AuthKey)

    fetch(BACKEND_API_HOST + 'finance/import', {
      method: 'POST',
      headers: {
        'Authorization': 'bearer ' + AuthKey
      },
      body: formData
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error(error);
      })
      .then((response) => {
        if (response && response.success) {
          Swal.fire({
            title: 'Berhasil!',
            text: response.message,
            icon: 'success',
            showConfirmButton: false,
            timer: 800,
          })
          window.location.reload();
        }
        else if (response) {
          Swal.fire({
            title: 'Gagal!',
            text: response.message,
            icon: 'warning',
            showConfirmButton: false,
            timer: 1200,
          })
        }

        this.setState({ loading: false, importFile: null,})
        this.props.changeState({ modalimport: false })
      })
  }

  render() {
    return(
      <Modal size="sm" zIndex={999} isOpen={this.props.modalImport} toggle={() => this.props.changeState({
        modalImport: false,
      })} style={{ maxWidth: "500px"}}>
        <ModalHeader toggle={() => {
          this.props.changeState({
            modalImport: false,
          })
        }} className="pengumuman-modal-header">
          <div className="pengumuman-modal-header-font">Import Laporan Keuangan</div>
        </ModalHeader>
        <ModalBody className="pengumuman-modal-body">
          <div>
            <div style={{ fontSize: '14px' }}>
              <a>Anda bisa mengunduh template yang sudah kami sediakan untuk mempermudah
                pengimportan.</a><br/>
              <a style={{color: "#057CE4"}} onClick={this.exportTemplate}>Unduh Template</a>
            </div>
            <div style={{
              position: 'relative',
              width: '100%',
              backgroundColor: '#F9F9F9',
              padding: 16,
              borderRadius: 6,
              marginTop: 8,
              border: "1px dashed #DDDDDD"
            }}>
              <input
                type='file'
                     accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                     onChange={(event) => {
                       this.setState({
                         importFile: event.target.files[0],
                       })
                     }}
              /><br/>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="pengumuman-modal-footer">
          {this.state.importLoading ?
            <button className={'btn btn-primary'} style={{textTransform: "none", width: "100%"}}
                    disabled={true}><i className="fa fa-refresh fa-spin"></i> Sedang mengupload data
            </button>
            :
            <button
              className={this.state.importFile === null ? 'btn bg-secondary-custom' : 'btn btn-primary'}
              style={{textTransform: "none", width: "100%"}}
              disabled={this.state.importFile === null} onClick={this.importExcel}>Import
              Data</button>
          }
        </ModalFooter>
      </Modal>
    )
  }
}

export default ImportFinance